<form (submit)="save()" id="transaction_form" [formGroup]="transaction_form" fxLayout="column"
    fxLayoutAlign="start stretch" rsControlErrorForm>
    <mat-form-field appearance="outline" rsControlError>
        <mat-label>{{ 'step_one_first_string_info' | translate }}</mat-label>
        <div fxLayout="row">
            <mat-icon [ngClass]="{'make-visible': transaction_form.controls.name.value}">person</mat-icon>
            <input #field matInput type="text" autocomplete="name" formControlName="name">
        </div>
    </mat-form-field>
    <mat-form-field appearance="outline" rsControlError>
        <mat-label>{{ 'step_one_second_string_info' | translate }}</mat-label>
        <div fxLayout="row">
            <mat-icon [ngClass]="{'make-visible': transaction_form.controls.email.value}">email</mat-icon>
            <input #field appTrim matInput type="email" autocomplete="off" [matAutocomplete]="listDomainAutoComplete"
                formControlName="email" email>
            <mat-autocomplete class="{{!checkInputEmail ? 'hide-list-domain' : ''}}"
                #listDomainAutoComplete="matAutocomplete">
                <mat-option *ngFor="let option of domainEmail" [value]="userEmail +'@'+option">
                    {{userEmail}}@{{option}}
                </mat-option>
            </mat-autocomplete>
        </div>
    </mat-form-field>
    <mat-form-field appearance="outline">
        <mat-label>{{ 'step_one_third_string_info' | translate }}</mat-label>
        <ngx-mat-intl-tel-input class="tel-pref"
            [preferredCountries]="['ar', 've', 'cu','us', 'es', 'gt', 'uy', 'mx', 'co']" [enablePlaceholder]="true"
            [enableSearch]="true" name="whatsapp" formControlName="whatsapp">
        </ngx-mat-intl-tel-input>
    </mat-form-field>
    <mat-form-field appearance="outline" *ngIf="system1 && system1.attributes.account_required_send" rsControlError>
        <mat-label>{{ accountService.getValidatorAccount(system1.attributes.account_type).getLabelToAccountType() }} {{
            (system1.attributes.name || system1.id) }}</mat-label>
        <div fxLayout="row" fxLayoutGap="6px">
            <app-system-icon [ngClass]="{'make-visible': transaction_form.controls.address1.value}"
                [systemId]="system1.id" [alt]="system1.attributes.name"
                title="Cambiar saldo {{system1.attributes.name}}"></app-system-icon>
            <input #field appTrim matInput id="address1" type="text" formControlName="address1"
                [placeholder]="accountService.getValidatorAccount(system1.attributes.account_type).getPlaceholderToAccountType()">
        </div>
    </mat-form-field>

    <ng-container *ngIf="system2 && system2.attributes.account_required_receive">
        <mat-form-field appearance="outline" *ngIf="!specialsId(system2); else pagoMovil" rsControlError [ngClass]="{'have-network': system2 && system2.relationships && system2.relationships.networks && system2.relationships.networks.data.length > 0}">
            <mat-label>{{ accountService.getValidatorAccount(system2.attributes.account_type).getLabelToAccountType() }}
                {{(system2.attributes.name || system2.id) }}</mat-label>
            <div style="height: auto;" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="6px">
                <app-system-icon [ngClass]="{'make-visible':  transaction_form.controls.address2.value}"
                    [systemId]="system2.id" alt="{{system2.attributes.name}}"
                    title="Cambiar saldo {{system2.attributes.name}}"></app-system-icon>
                <input #field appTrim matInput id="address2" type="text" formControlName="address2"
                    [placeholder]="accountService.getValidatorAccount(system2.attributes.account_type).getPlaceholderToAccountType()">
            </div>
        </mat-form-field>
    </ng-container>

    <mat-form-field appearance="outline"
        *ngIf="system2 && system2.relationships && system2.relationships.networks && system2.relationships.networks.data.length > 0"
        rsControlError>
        <mat-label>{{ 'step_one_fourth_string_info_network' | translate }}</mat-label>
        <div style="height: auto;" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="8px">
            <mat-select [(value)]="networkTitle" (selectionChange)="onNetworkChange($event.value)"
                [disabled]="isMatSelectDisabled">
                <mat-select-trigger class="flex-row-start-center">
                    <span fxLayoutAlign="flex-start center" fxLayoutGap="8px">
                        <img src="../../../../assets/images/networks/{{getNetworkIdByTitle(networkTitle ?? '')}}.png"
                            width="24" height="24" alt="BNB smart chain">
                        <span>
                            {{ networkTitle }}
                        </span>
                    </span>
                </mat-select-trigger>
                <mat-option *ngFor="let network of filteredNetworks" [value]="network.network.attributes.title"
                    [disabled]="network.disabled">
                    <span fxLayoutAlign="space-between center" fxLayoutGap="8px">
                        <span fxLayoutAlign="space-between center" fxLayoutGap="8px">
                            <img src="../../../../assets/images/networks/{{network.network.id}}.png" width="24"
                                height="24" alt="BNB smart chain">
                            <span>
                                {{ network.network.attributes.title }}
                            </span>
                        </span>
                        <span>fee {{ networkHelper.getFeeByNetwork(network.network.id)}} {{
                            system2.relationships.currency.data?.id }}</span>
                    </span>
                </mat-option>
            </mat-select>
        </div>
    </mat-form-field>

    <mat-form-field appearance="outline" *ngIf="system2 && system2.id === 'vcc'" rsControlError>
        <mat-label>País de tu cuenta PayPal</mat-label>
        <mat-select #field required formControlName="origin">
            <mat-option *ngFor="let origin of originsPalpal" [value]="origin">
                {{ origin }}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <ng-template #pagoMovil>
        <app-pago-movil-form [systemId]="system2?.id"
            (updatePagoMovilValue)="updatePagoMovilValue($event)"></app-pago-movil-form>
    </ng-template>
    <div *ngIf="showCheckRequirements">
        <div *ngFor="let systemRequirement of systemRequirements">
            <mat-checkbox class="test-check" [required]="true" formControlName="check_requirements"
                *ngIf="systemRequirement.system === transaction.relationships['system' + systemRequirement.way].data.id">
                <div [innerHTML]="systemRequirement.requirements | translate: {
                       element_one: fee | decimalBySystem: transaction.relationships['system' + systemRequirement.way].data,
                       element_two: finalFee | decimalBySystem: transaction.relationships['system' + systemRequirement.way].data
                }"></div>
            </mat-checkbox>
        </div>
    </div>
    <div [ngClass]="{'without-vcc': system2 && system2.id !== 'vcc'}" class="button-actions">
        <button (click)="closeForm()" *ngIf="system2 && system2.id === 'vcc'" mat-stroked-button>{{ 'cancel' | translate
            }}</button>
        <app-submit [ngClass]="{'dark-background': system2 && system2.id !== 'vcc'}" [loading]="transaction.is_saving"
            [disabled]="(!transaction_form.valid || (specialsId(system2) && !checkAccountPagoMovil)) || !transactionFormService.transactionHasErrors()">
            {{ 'place_an_order' | translate }}
        </app-submit>
    </div>
</form>